export default function LocationMap() {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Visit Our Facility</h2>
          <p className="text-xl text-gray-600">
            Located in the heart of Sportsville with easy access and ample parking
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="aspect-w-16 aspect-h-9">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.733!2d-118.2437!3d34.0522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDAzJzA4LjAiTiAxMTjCsDE0JzM3LjAiVw!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="NextZen Soccer Academy Location"
            ></iframe>
          </div>
          
          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Address</h3>
                <p className="text-gray-600">
                  123 Soccer Academy Drive<br />
                  Sportsville, CA 90210
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-car-line text-2xl text-blue-600 w-8 h-8 flex items-center justify-center"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Parking</h3>
                <p className="text-gray-600">
                  Free parking available<br />
                  200+ spaces on-site
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-bus-line text-2xl text-purple-600 w-8 h-8 flex items-center justify-center"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Public Transit</h3>
                <p className="text-gray-600">
                  Bus routes 15, 22, 45<br />
                  Metro station 0.5 miles
                </p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Directions</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">From Downtown</h4>
                  <p className="text-gray-600">Take Highway 101 North, exit at Sports Boulevard, turn right and continue for 2 miles. The academy will be on your left.</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">From Airport</h4>
                  <p className="text-gray-600">Take Airport Boulevard to Highway 405 South, merge onto Highway 101 North, then follow downtown directions.</p>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Get Directions
              </button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}